import $ from "jquery";

export const init = () => {
  $(".sub-nav-toggle").on("click", function () {
    $(this).parents(".sub-nav-container").find(".sub-nav-box").slideToggle();
    $(this).toggleClass("open");
  });
};
